export const gold = {
  goldSubscriptionActivated: "Gold subscription activated",
  subscribeToGlobalComixGold: "Subscribe to GlobalComix Gold",
};
